import { Col, Image, Layout, Row } from "antd";
import { motion } from "framer-motion";
import React from "react";
import "./Style.css";

import IMG1 from "../../assets/double/1.svg";
import IMG2 from "../../assets/double/2.svg";
import IMG3 from "../../assets/double/3.svg";
import IMG4 from "../../assets/double/4.svg";
import IMG5 from "../../assets/double/5.svg";
import IMG6 from "../../assets/double/6.svg";
import IMG7 from "../../assets/double/7.svg";

const textContent = [
  "My love for Xiangqi, or Chinese chess, runs deep, embedded in family history that stretches back four generations - from my great-grandfather, to my grandfather, then my father, and now, to me. Although I only know of my great-grandfather’s skill through my grandfather’s stories, those tales ignited my fascination with this ancient game.",
  "A fascinating fact: Did you know that Xiangqi has existed for over 1,200 years? It is believed to have originated from Chaturanga, an ancient Indian game from the 5th or 6th century. Chaturanga spread westward to become chess and eastward to evolve into Xiangqi. This rich heritage has only deepened my love for Xiangqi, giving it a historical and cultural significance that resonates profoundly.",
  "Learning Xiangqi is a unique challenge compared to learning chess, another game I love and play regularly. At first, I struggled with Xiangqi - the characters on the pieces, written in Chinese, were difficult to remember. But the more I played, the more I became captivated by the complexity of the game and its strategic depth. Rooted in Confucian tradition, Xiangqi has long been revered in Vietnam as a test of leadership, foresight, and subtlety - the true game of generals.",
  "For me, Xiangqi has become a special bond with my grandfather. It is an intimate game between two, and through countless matches, we have become close companions over the board. He taught me strategies from his generation - techniques refined over years, passed down by his skilled friends or from hard-fought games. Yet, as we played, I realized there were new strategies and techniques that could enhance our approach, moving beyond traditional learning rooted solely in experience. Inspired by this, I founded the Double Canon club.",
];

const itemsSlide = [
  { id: 1, content: IMG2 },
  { id: 2, content: IMG3 },
  { id: 3, content: IMG4 },
];
const itemsSlide2 = [
  { id: 5, content: IMG5 },
  { id: 6, content: IMG6 },
  { id: 7, content: IMG7 },
];

const { Content } = Layout;

const DoubleCanonsPage = () => {
  return (
    <Layout className="bg-double-canons">
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <Image
          className="image-cover"
          src={IMG1}
          alt="Image 2"
          preview={false}
        />
      </div>
      <Content
        style={{
          padding: "40px 20px",
          maxWidth: "1400px",
          margin: "0 auto",
          overflow: "hidden",
        }}
      >
        <Row gutter={[30, 30]} align="middle">
          <Col xs={24} sm={24} md={24}>
            <div className="text-section">My Passion for Chinese Chess</div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              {textContent.map((x, ix) => {
                return (
                  <div key={ix}>
                    <p
                      className="text-color-2"
                      style={{
                        display: "block",
                        marginBottom: "16px",
                        fontSize: "16px",
                        lineHeight: "1.8",
                        textAlign: "justify",
                      }}
                    >
                      {x}
                    </p>
                  </div>
                );
              })}
            </motion.div>
          </Col>
        </Row>
        <br />
        <br />
        <Row gutter={[30, 30]}>
          <div className="double_canons_slide">
            {itemsSlide.map((el, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="double_canons_slide-item"
              >
                <Image
                  className="double_canons_slide-item-img"
                  src={el.content}
                  alt={el.id}
                  preview={false}
                />
              </motion.div>
            ))}
          </div>
        </Row>
        <br />
        <br />
        <Row gutter={[30, 30]} align="middle">
          <div
            className="text-section"
            style={{
              textAlign: "center",
              width: "100%",
            }}
          >
            Double Canon was established with a mission:
          </div>
          <div
            className="text-color-2"
            style={{
              display: "block",
              marginBottom: "16px",
              fontSize: "16px",
              lineHeight: "1.8",
              textAlign: "justify",
              padding: "16px",
            }}
          >
            To use Xiangqi as a bridge between generations, from the elderly to
            Generation Alpha. We trained 18 members, introducing them to
            structured, modern strategies and tactics. As club leader, I
            encouraged members to join the Chinese Chess Club online platform,
            creating a community that connected us beyond in-person gatherings.
          </div>
          <div className="double_canons_slide_2">
            {itemsSlide2.map((el, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="double_canons_slide_2-item"
              >
                <Image
                  className={
                    "double_canons_slide_2-item-img image_slide_" + index
                  }
                  src={el.content}
                  alt={el.id}
                  preview={false}
                />
              </motion.div>
            ))}
          </div>
          <div
            className="text-color-2"
            style={{
              display: "block",
              marginBottom: "16px",
              fontSize: "16px",
              lineHeight: "1.8",
              textAlign: "justify",
              padding: "16px",
            }}
          >
            Our vision expanded, seeking 34 new members, including older players
            who could impart invaluable wisdom to the younger generation. To
            foster intergenerational bonds, we hosted the “Ancient Tree” event -
            a weekly gathering at Hanoi Chess House, where generations came
            together to play and exchange insights: the younger brought fresh
            strategies, while the elders contributed time-honed wisdom.
            Together, we preserved Xiangqi’s legacy, blending it with innovative
            approaches to connect generations through this timeless game.
          </div>
          <div
            className="text-color-2"
            style={{
              display: "block",
              marginBottom: "16px",
              fontSize: "16px",
              lineHeight: "1.8",
              textAlign: "justify",
              padding: "16px",
            }}
          >
            Through my games with my grandfather, I realized how vital it is to
            cultivate passion across generations. Regular exchanges with him
            deepened my appreciation for the insights of the past, and I aspire
            to meet others, hearing their stories and learning from their life
            lessons. This intergenerational exchange not only enriches the
            younger generation but also revitalizes the elders, making them feel
            youthful and vibrant.
          </div>
        </Row>
        <br />
        <br />
      </Content>
    </Layout>
  );
};

export default DoubleCanonsPage;
